import React, { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  Grid,
  Alert,
  AlertTitle,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import the carousel styles
import CloseIcon from "@mui/icons-material/Close";

import couch from "../assests/couch.jpg";
import table from "../assests/table.jpg";
import sofa from "../assests/sofa.jpg";

// import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";

import Header from "./header";
import Button from "@mui/material/Button";

// import OutlinedInput from "@mui/material/OutlinedInput";

import API from "../APIUrls";
import { apiData } from "../services/api-methods";

import { useNavigate } from "react-router-dom";
import Footer from "./footer";

const validationSchema = yup.object({
  name: yup.string().required("Name  is required"),

  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  property: yup.string().required("property is required"),
  contactNo: yup
    .string()
    .matches(
      /^[0-9]{10}$/,
      "Phone number must be 10 digits long and contain only numbers"
    )
    .required("Mobile number is required"),
});

const Landing = () => {
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  // const [products, setProducts] = useState([]);
  const [coupon, setCoupon] = useState("");
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(true);
  const [message, setMessage] = useState({});
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      address: "",
      property: "",
      contactNo: "",
      products: [],
    },
    validationSchema: validationSchema,

    onSubmit: async (values, { setSubmitting }) => {
      try {
        setLoading(true);

        let tempData = await apiData("post", API.enquiry, values);
        if (tempData.statusCode >= 200 && tempData.statusCode < 400) {
          navigate(`/congratulation/${coupon}`);
        }
        if (tempData.statusCode === 400) {
          setMessage({ status: "error", msg: "Email Already registered" });
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (err) {
      } finally {
        setLoading(false);
      }
    },
  });

  const handleInputChange = async (e) => {
    try {
      setLoading(true);
      setSearch(e.target.value);
      let tempData = await apiData("get", API.property, {
        query: e.target.value,
      });

      setProperties(tempData.data ? tempData.data : []);
    } catch (Err) {
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   async function fetchData() {
  //     let tempData = await apiData("get", API.product);
  //     setProducts(tempData.data ? tempData.data : []);
  //   }
  //   fetchData();
  // }, []);

  return (
    <div className="main">
      <Header />
      {message && message.status && (
        <Alert severity={`${message.status}`}>
          <AlertTitle>{message.status}</AlertTitle>
          {message.msg && <>{message.msg}</>}
        </Alert>
      )}

      <form className="LandingPgae" onSubmit={formik.handleSubmit}>
        <Dialog
          open={open}
          PaperProps={{ style: { borderRadius: "15px" } }}
          onClose={() => (
            <CloseIcon
              style={{ cursor: "pointer", textAlign: "right" }}
              onClick={() => setOpen(false)}
            />
          )}
        >
          <DialogContent dividers>
            <CloseIcon
              style={{
                position: "absolute",
                right: 2,
                top: 2,
                cursor: "pointer",
                color: "#dfdfdf",
              }}
              color="secondary"
              onClick={() => setOpen(false)}
            />
            <Typography
              variant="body1"
              gutterBottom
              style={{ fontSize: "20px" }}
            >
              Let us know which property you saw our furniture in and access an
              exclusive discount!
            </Typography>
          </DialogContent>
        </Dialog>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={8} className="carouselSection">
            <Carousel
              transitionEffect="fade"
              autoPlay
              infiniteLoop
              showThumbs={false}
            >
              <div>
                <img src={couch} alt=" 1" className="responsive-image" />
              </div>
              <div>
                <img src={table} alt=" 2" className="responsive-image" />
              </div>
              <div>
                <img src={sofa} alt=" 3" className="responsive-image" />
              </div>
            </Carousel>
          </Grid>
          <Grid item xs={4} className="formStyle">
            <h3 style={{ fontSize: "16px" }}>
              Tell us where you saw our furniture to unlock your exclusive 5%
              discount!
            </h3>
            <Grid item xs={12} md={12} lg={12}>
              <Box
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1, width: "50ch" },
                }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  name="name"
                  type="text"
                  label="Name"
                  fullWidth
                  onChange={formik.handleChange}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1, width: "50ch" },
                }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  name="email"
                  type="email"
                  label="Email"
                  fullWidth
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1, width: "50ch" },
                }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  name="contactNo"
                  type="text"
                  label="Mobile Number"
                  fullWidth
                  onChange={formik.handleChange}
                  error={
                    formik.touched.contactNo && Boolean(formik.errors.contactNo)
                  }
                  helperText={
                    formik.touched.contactNo && formik.errors.contactNo
                  }
                />
              </Box>
            </Grid>
            <Grid className="dropdownList" item xs={12}>
              <Box
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1, width: "50ch" },
                }}
                noValidate
                autoComplete="off"
              >
                <TextField
                  label="Which property did you see us in?"
                  name="property"
                  value={
                    formik.values.property === ""
                      ? search
                      : properties.find(
                          (item) => item._id === formik.values.property
                        ).address
                  }
                  onChange={handleInputChange}
                  error={
                    formik.touched.property && Boolean(formik.errors.property)
                  }
                  helperText={formik.touched.property && formik.errors.property}
                />
                {formik.values.property === "" && properties.length > 0 && (
                  <div className="productListSu">
                    {properties.map((suggestion) => (
                      <MenuItem
                        key={suggestion._id}
                        onClick={() => {
                          formik.setFieldValue("property", suggestion._id);

                          setCoupon(suggestion.coupon);
                        }}
                      >
                        {suggestion.address}
                      </MenuItem>
                    ))}
                  </div>
                )}
              </Box>
            </Grid>

            {/* <Grid className="dropdownList" item={12}>
              <Box
                component="form"
                sx={{
                  "& .MuiFormControl-root": { width: "100%" },
                  "& .MuiTextField-root": { m: 1, width: "100%" },
                }}
                noValidate
                autoComplete="off"
              >
                <FormControl>
                  <InputLabel id="demo-multiple-chip-label">
                    Product(s)
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-chip-label"
                    id="demo-multiple-chip"
                    multiple
                    value={formik.values.products}
                    onChange={(e) => {
                      formik.setFieldValue("products", e.target.value);
                    }}
                    input={
                      <OutlinedInput
                        id="select-multiple-chip"
                        label="Product(s)"
                      />
                    }
                  >
                    {products.length > 0 ? (
                      products.map((name) => (
                        <MenuItem key={name._id} value={name._id}>
                          {name.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem>No Products found</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Box>
            </Grid> */}

            <Grid item={12} className="buttonContainer">
              <Button
                variant="contained"
                style={{ backgroundColor: "#426e5a" }}
                type="submit"
                disabled={loading}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>

      <Footer />
    </div>
  );
};

export default Landing;
